import {
  formatWeekday,
  formatSeconds,
  formatMinute,
  formatHour,
  formatDay,
} from './format-dates.js';

const THIRTY_MINUTES = 1000 * 60 * 30;
const FIVE_MINUTES = 1000 * 60 * 5;
const FIVE_SECONDS = 1000 * 5;
const FIFTY_MILLISECONDS = 50;

export function formatDateBasedOnDomain(
  date: Date,
  domain: [Date, Date],
  width: number,
) {
  if (width <= 0) {
    return '';
  }
  const [start, end] = domain;
  const timeInMs = date.getTime();
  const msPerPixel =
    (Math.max(start.getTime(), end.getTime()) -
      Math.min(start.getTime(), end.getTime())) /
    width;

  if (msPerPixel < FIFTY_MILLISECONDS) {
    return formatSeconds(timeInMs);
  } else if (msPerPixel <= FIVE_SECONDS) {
    return formatMinute(timeInMs);
  } else if (msPerPixel <= FIVE_MINUTES) {
    return formatHour(timeInMs);
  } else if (msPerPixel <= THIRTY_MINUTES) {
    return formatDay(timeInMs);
  } else {
    return formatWeekday(timeInMs);
  }
}
